// extracted by mini-css-extract-plugin
export default {"sidebarMenuButtonWrapper":"SidebarMenuButton-module--sidebarMenuButtonWrapper--fe2db"};